import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state: NotificationState = {
    entries: [],
    error: null,
    callback: null,
    count: 0,
    lastTimestamp: 0,
    lastStorageTimestamp: 0,
};

let index = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default index;